import Enum from "./Enum";

export default Enum.create( {
	INDETERMINATE: "INDETERMINATE",
	VISIBLE: "VISIBLE",
	HIDDEN: "HIDDEN",
} );
